import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Checkbox } from '@telus-uds/components-web';

import Label from './common/label';
import request from '../../../../../utils/request';

const MultiChannel = ({
  fieldData,
  setFieldData,
  formErrors,
  setFormErrors
}) => {
  const [channelList, setChannelList] = useState([]);
  const fieldError = 'channels' in formErrors;

  const handleChannelSelect = ({ target: { value } }) => {
    let selectedChannels = [...fieldData.channels];
    if (selectedChannels.includes(value))
      selectedChannels = _.pull(selectedChannels, value);
    else selectedChannels.push(value);

    if (selectedChannels.length === 0) {
      setFormErrors(previousValue => ({
        ...previousValue,
        channels: { message: 'Field is required' }
      }));
    } else {
      setFormErrors(previousValue => {
        const newValue = { ...previousValue };
        delete newValue.channels;
        return newValue;
      });
    }

    setFieldData(previousValue => ({
      ...previousValue,
      channels: selectedChannels
    }));
  };

  useEffect(() => {
    const getChannels = async () => {
      const result = await request.get('/channels');
      if (result) {
        const transformedResult = _.get(result, 'data.channels', []).map(
          item => ({
            label: item.name,
            value: item.name
          })
        );
        setChannelList(transformedResult);
      }
    };
    getChannels();
  }, []);

  return (
    <div>
      <Label labelName="Channels *" />
      {fieldError && (
        <div className="error-notification">
          <p>{formErrors.channels.message}</p>
        </div>
      )}
      <div
        style={{ position: 'relative', width: '100%', marginBottom: '-1rem' }}
        className="frg-select-container color-light input-container"
      >
        <div
          role="group"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            rowGap: '0.5rem'
          }}
        >
          {channelList &&
            channelList.length > 0 &&
            channelList.map(channel => {
              return (
                <Checkbox
                  key={channel.value}
                  id={`channel-${channel.value}`}
                  checked={fieldData.channels.includes(channel.value)}
                  onChange={() => handleChannelSelect({ target: { value: channel.value } })}
                  name="channels"
                  value={channel.value}
                  label={channel.label}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};

MultiChannel.propTypes = {
  formErrors: PropTypes.shape({
    channels: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    role: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    contactNumber: PropTypes.string,
    provinces: PropTypes.arrayOf(PropTypes.string),
    channels: PropTypes.arrayOf(PropTypes.string),
    outlet: PropTypes.string,
    cpmsId: PropTypes.string,
    xid: PropTypes.string,
    storeCode: PropTypes.string,
    dealership: PropTypes.arrayOf(PropTypes.string),
    channelOrgCode: PropTypes.string,
    salesManager: PropTypes.string,
    salesManagerEmail: PropTypes.string
  }).isRequired
};

export default MultiChannel;
